import { Parameter, Parameters } from '../../../models/index';
import { UseCase } from '../../UseCase';

export namespace SetParameter {
    export interface Params<P extends string> {
        params?: Parameters<P>;
    }
}

export class SetParameter<P extends string>
    implements UseCase<SetParameter.Params<P>, Parameters<P>>
{
    execute({ params }: SetParameter.Params<P>): Parameters<P> {
        params = params || {};
        params.parameters = params.parameters || [];

        return params;
    }
}
